module.exports = __webpack_public_path__ + "img/fontana-pubblica.18e896a7.svg";